import React from 'react'

import Select from 'react-select'

class MultiSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: []
        };

        this.handleSelectChange = this.handleSelectChange.bind(this)
    }

    handleSelectChange(value) {
        this.setState({value});
        this.props._onChange && this.props._onChange(value)
    }

    render() {
        const {value} = this.state;
        return (
            <Select
                multi
                inputProps={{disabled: true}}
                onChange={this.handleSelectChange}
                simpleValue
                value={value}
                {...this.props}
            />
        )
    }
}

export default MultiSelect



// WEBPACK FOOTER //
// ./src/components/components/multiselect/multiselect.js